<template>
  <div v-if="images">
    <gallery :images="imagesRaw" :id="`gallery-${alias}`" :index="index" @close="index = null"></gallery>
    
    <v-row no-gutters justify="start">
    <v-col
      v-for="(image, imageIndex) in images"
        :key="imageIndex"
        @click="index = imageIndex"
        class="pa-3"
        cols="12"
        :sm="(fullSize)?12:6"
        :md="(fullSize)?12:4"
        :lg="(fullSize)?12:2"
    >
      <v-img
        :src="(_.isObject(image))?image.thumb:image"
        :aspect-ratio="aspectRatio"
        :contain="contain"
        class="white lighten-2 cursorClickable"
      >
        <template v-slot:placeholder>
          <v-row
            class="fill-height ma-0"
            align="center"
            justify="center"
          >
            <v-progress-circular
              indeterminate
              color="grey lighten-5"
            ></v-progress-circular>
          </v-row>
        </template>
      </v-img>
    </v-col>
  </v-row>
  </div>
</template>

<script>
  import VueGallery from 'vue-gallery';
  
  export default {
    props:{
        alias:{
            type:Number
        },
        images:{
            type:Array
        },
        fullSize:{
          type:Boolean,
          default:false
        },
        contain:{
          type:Boolean,
          default:false
        },
        aspectRatio:{
          type:Number
        }
    },
    data: function () {
        return {
            index: null
        };
    },
    computed: {
        imagesRaw(){
            return this._.map(this.images,(image)=>{
              return (this._.isObject(image))?image.src:image
            });
        }
    },

    components: {
      'gallery': VueGallery
    },
  }
</script> 
